// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".segment-metric-total-row{font-size:12px}.segment-metric-total-row mp-text-highlight{margin:0}.segment-metric-total-row .segment-metric-total-label{color:var(--tertiary-text-color);padding-right:4px}.segment-metric-total-row .segment-metric-total-value{color:var(--inverted-component-text-color);padding-right:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
